'use client';

import { ErrorLayout, Footer, Main } from '@/components';
import { COLOR_MODE_COOKIE_NAME, DEFAULT_COLOR_MODE } from '@/helpers';
import { cx } from '@onbeam/business-styled-system/css';
import { flex, vstack } from '@onbeam/business-styled-system/patterns';
import { Button } from '@onbeam/business-ui';
import { getCookie } from '@onbeam/utils';
import Link from 'next/link';
import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { customScrollbar } from '@onbeam/business-styled-system/recipes';

type Props = { error: Error & { digest?: string } };

const GlobalError = async ({ error }: Props) => {
  const colorMode = getCookie(COLOR_MODE_COOKIE_NAME) || DEFAULT_COLOR_MODE;

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body
        className={cx(
          colorMode,
          customScrollbar(),
          vstack({
            minH: '[100vh]',
            bg: 'mono.primaryFg',
            color: 'mono.primaryBg',
            fontFamily: 'main',
            overflowX: 'hidden',
          }),
        )}
      >
        <Main>
          <ErrorLayout
            errorCode="500"
            title="An error has occurred."
            description="Sorry, we encountered an unexpected error."
          >
            <div
              className={flex({
                gap: '2',
              })}
            >
              <Button as={Link} href="/" variant="secondary">
                Go back home
              </Button>
              <Button onClick={() => window.location.reload()}>
                Reload page
              </Button>
            </div>
          </ErrorLayout>
        </Main>
        <Footer />
      </body>
    </html>
  );
};

export default GlobalError;
